<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div>
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="用户信息" prop="userInfo">
            <el-input style="width: 232px" v-model="searchForm.userInfo" placeholder="请输入用户信息" clearable></el-input>
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input style="width: 232px" v-model="searchForm.goodsName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="评论星数" prop="brandId">
            <el-select v-model="searchForm.star" placeholder="请选择评论星数" filterable clearable>
              <el-option v-for="item in stars" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="hasShopping">
            <el-select style="width: 232px" v-model="searchForm.showFlag" placeholder="请选择状态" filterable clearable>
              <el-option label="显示" value="true"></el-option>
              <el-option label="隐藏" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" prop="joinTimeStart">
            <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评论时间" prop="lastActiveTimeStart">
            <el-date-picker v-model="value2" style="width: 232px" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="评论类型" prop="brandId">
            <el-select v-model="searchForm.type" placeholder="请选择评论类型" style="width: 232px" filterable clearable>
              <el-option label="系统新增" value="1"></el-option>
              <el-option label="用户评论" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-btn">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button type="primary" :loading="exporting" @click="add()">新增评论</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="温馨提示" :visible.sync="isS" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>是否确认小程序页面{{ isName }}该评论？
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isS = false">取消</div>
          <div class="info-s" @click="updateStatus()">确定</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data() {
    return {
      isS: false,
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品评论', path: '/shopManagement/shopList', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '商品评论', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      list: [],
      searchForm: {
        userInfo: '', // 	
        goodsName: '', // 	
        star: '', // 	
        showFlag: '', // 	
        orderTimeStart: '', // 	
        orderTimeEnd: '', // 	
        submitTimeStart: '', // 	
        submitTimeEnd: '',//
        pageNo: 1,
        pageSize: 10,
        type: ''
      },
      value1: [],
      value2: [],
      stars: [
        {
          id: 1,
          name: '一星'
        },
        {
          id: 2,
          name: '二星'
        },
        {
          id: 3,
          name: '三星'
        },
        {
          id: 4,
          name: '四星'
        },
        {
          id: 5,
          name: '五星'
        },
      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '用户头像',
          minWidth: '100',
          render: (h, scope) => {
            let img = scope.row.userAvatar ? scope.row.userAvatar : require('../../../assets/icon_touxiang_106@2x.png')
            return (
              <div>
                <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
              </div>
            )
          }
        },
        {
          label: '用户信息', prop: 'username', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <div>昵称：{scope.row.userName}</div>
                <div>ID：{scope.row.userId || '--'}</div>
                <div>电话：{scope.row.userPhone || '--'}</div>
              </div>
            )
          }
        },
        {
          label: '下单时间', prop: 'orderTime', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>{scope.row.orderTime || '--'}</div>
            )
          }
        },
        // { label: '平台', prop: 'platformName', minWidth: '120' },
        {
          label: '订单编号', prop: 'orderNo', minWidth: '180',
          render: (h, scope) => {
            return (
              <div>{scope.row.orderNo || '--'}</div>
            )
          }
        },
        { label: '商品名称', prop: 'goodsName', minWidth: '220' },
        { label: '商品规格', prop: 'goodsSkuName', minWidth: '100' },
        { label: '评论星数', prop: 'starLabel', minWidth: '100' },
        {
          label: '评论内容', prop: 'content', minWidth: '400',
          render: (h, scope) => {
            return (
              <div>
                <p style="max-height: 60px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{scope.row.content ? scope.row.content : '--'}</p>
              </div>
            )
          }
        },
        {
          label: '图片', prop: 'imgs', minWidth: '120',
          render: (h, scope) => {
            let img = scope.row.imgList ? scope.row.imgList[0] : ''
            let v = ''
            if (img) {
              v = <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
            } else {
              v = '--'
            }
            return (
              <div>{v}</div>
              // <div>
              //   <el-image style="width:64px;height:64px;border-radius:50%;" src={img} preview-src-list={[img]} lazy></el-image>
              // </div>
            )
          }
        },
        { label: '评论时间', prop: 'submitTime', minWidth: '200' },
        { label: '评论类型', prop: 'typeLabel', minWidth: '120' },
        { label: '状态', prop: 'statusLabel', minWidth: '120' },
        {
          label: '操作',
          minWidth: '200',
          fixed: 'right',
          render: (h, scope) => {
            let v = ''
            if (scope.row.typeLabel != '用户评论') {
              v = <span style='color:#2D46EE;cursor:pointer;margin-left:10px;' onClick={() => { this.add(scope.row.id) }}>编辑</span>
            } else {
              v = ''
            }
            return (

              <div>
                {/* <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.todetail(scope.row) }}>显示</span> */}
                <span style='color:#2D46EE;cursor:pointer;margin-left:10px;margin-right:10px' onClick={() => { this.isShow(scope.row) }}>{scope.row.statusL}</span>
                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.todetail(scope.row.id) }}>查看</span>
                {/* <span style='color:#2D46EE;cursor:pointer;margin-left:10px;' onClick={() => { this.add(scope.row.id) }}>查看/编辑</span> */}
                {v}
              </div >
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false,
      isName: '',
      cId: '',
      showFlag: ''
    }
  },
  created() {
    this.getPageList()
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'addComment') {
      next(vm => {
        vm.getPageList();
      });
    } else {
      next(vm => {
        vm.getPageList();
      });
    }
  },
  methods: {
    add(id) {
      this.$router.push({
        name: 'addComment',
        query: {
          id: id
        }
      })
    },
    updateStatus() {
      let data = {
        id: this.cId,
        showFlag: this.showFlag
      }
      this.axios.post('/psGoodsEvaluation/updateShowFlag', data).then(res => {
        if (res.code == 0) {
          this.$message.success('更改成功')
          this.isS = false
          this.getPageList()
        }
      })
    },
    isShow(row) {
      this.isS = true
      this.isName = row.statusL
      this.cId = row.id
      console.log(row.showFlag)
      this.showFlag = !row.showFlag
    },
    fetchData(type) {
      this.page.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.value1 = []
        this.value2 = []
        this.searchForm.submitTimeStart = ''
        this.searchForm.submitTimeEnd = ''
        this.searchForm.orderTimeStart = ''
        this.searchForm.orderTimeEnd = ''
        this.searchForm.userInfo = ''
        this.searchForm.userInfo = ''
        this.searchForm.goodsName = ''
        this.searchForm.star = ''
        this.searchForm.showFlag = ''
        this.searchForm.type = ''
      }
      this.getPageList()
    },
    getPageList() {
      if (this.value1 && this.value1.length > 0) {
        this.searchForm.orderTimeStart = this.value1[0];
        this.searchForm.orderTimeEnd = this.value1[1];
      } else {
        this.searchForm.orderTimeStart = ''
        this.searchForm.orderTimeEnd = ''
      }
      if (this.value2) {
        this.searchForm.submitTimeStart = this.value2[0];
        this.searchForm.submitTimeEnd = this.value2[1];
      } else {
        this.searchForm.submitTimeStart = ''
        this.searchForm.submitTimeEnd = ''
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.axios.post('/psGoodsEvaluation/pageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            res.data.list.forEach(item => {
              if (item.showFlag == false) {
                item.statusLabel = '隐藏'
                item.statusL = '显示'
              } else {
                item.statusLabel = '显示'
                item.statusL = '隐藏'
              }
            })
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection(e) { },
    handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getPageList()
    },
    handleCurrentChange(e) {
      this.page.pageNo = e;
      this.getPageList()
    },
    todetail(id) {
      this.$router.push({
        name: 'lookComment',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);

  .el-dialog__body {
    padding: 30px 25px;
    height: 800px;
    flex: 1;
    overflow: auto;
  }
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
  padding-left: 37px;
}

.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#base-list {
  margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}

.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }

  .form-btn {
    /deep/ .el-form-item__content {
      line-height: 36px;
      margin-left: 50px;
    }
  }
}

/deep/ .el-table__row {
  .el-table__cell {
    padding: 12px 0;
  }
}

/deep/ .el-table {
  color: #303033;
}
</style>

